import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export function KpiCard({
  label,
  value,
  icon: Icon,
  footer,
  accent = 'primary',
  className,
}: {
  label: string
  value: ReactNode
  icon: LucideIcon
  footer?: ReactNode
  accent?: 'primary' | 'cyan' | 'success' | 'warning' | 'danger' | 'muted'
  className?: string
}) {
  const accentClass = {
    primary: 'text-primary bg-primary/10',
    cyan: 'text-brand-2 bg-brand-2/12',
    success: 'text-success bg-success/12',
    warning: 'text-warning bg-warning/15',
    danger: 'text-danger bg-danger/12',
    muted: 'text-muted-foreground bg-muted',
  }[accent]
  return (
    <Card className={cn('group relative overflow-hidden p-4 transition-shadow hover:shadow-md', className)}>
      <div className="flex items-start justify-between gap-2">
        <p className="text-[12.5px] font-medium text-muted-foreground">{label}</p>
        <span className={cn('flex size-7 items-center justify-center rounded-lg', accentClass)}>
          <Icon className="size-[15px]" strokeWidth={2} />
        </span>
      </div>
      <div className="mt-2 text-[26px] leading-none font-semibold tracking-tight tabular">{value}</div>
      {footer && <div className="mt-3 text-xs text-muted-foreground">{footer}</div>}
    </Card>
  )
}
